import { Component, ChangeDetectionStrategy } from '@angular/core';
import { takeUntil } from 'rxjs';
import { BaseDialogComponent } from '@src/app/modules/base';

import { previewInputDataType } from '../types';

@Component({
  selector: 'photo-preview',
  templateUrl: './photo-preview.component.html',
  styleUrls: ['./photo-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoPreviewComponent extends BaseDialogComponent<previewInputDataType, void> {
  photoSrc?: string;
  loading: boolean = false;

  ngOnInit(): void {
    super.ngOnInit();

    this.loading = true;
    this.data?.photoSrc$.pipe(takeUntil(this.destroyed$$)).subscribe(photoSrc => {
      this.photoSrc = photoSrc;
      this.loading = false;
      this.cdr.markForCheck();
    });
  }
}
